import AabIconButton from './AabIconButton';

customElements.define('aab-icon-button', AabIconButton);
